/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React, { Component } from 'react'
import { Link } from "react-router-dom"
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import { logout } from 'actions/authAction'
import { connect } from 'react-redux'
import Lang from '../../lang';
import history from '../../history';
import { Translation } from 'react-i18next';
import IndexDropdown from 'components/Dropdowns/IndexDropdown';
class Navbar extends Component {
  breadCrumb = (loc) => {
    return (
      <Translation>
        {t =>
          <>
            <Link className="text-white  text-lg  hidden lg:inline-block font-semibold" to="/admin/dashboard">{t('dashboard')}</Link>
            <span className="ml-2 text-white text-md opacity-80 hidden lg:inline-block font-semibold">/ {t(loc)}</span>
          </>
        }
      </Translation>
    )
  }
  pageLocation = (page) => {
    switch (page) {
      case "/admin/dashboard":
        return (
          <Translation>
            {t =>
              <>
                <Link className="text-white  text-lg  hidden lg:inline-block font-semibold" to="/admin/dashboard">{t('dashboard')}</Link>
              </>
            }
          </Translation>
        )
      case "/admin/ph": return (this.breadCrumb("PH"))
      case "/admin/cond": return (this.breadCrumb('elec-cond'))
      case "/admin/tds": return (this.breadCrumb('TDS'))
      case "/admin/orp": return (this.breadCrumb('orp'))
      case "/admin/oxygen": return (this.breadCrumb('do'))
      case "/admin/temp": return (this.breadCrumb('temp'))
      case "/admin/allAnalysis": return (this.breadCrumb('all-analysis'))
      case "/admin/chem1": return (this.breadCrumb('chem-1'))
      case "/admin/chem2": return (this.breadCrumb('chem-2'))
      case "/admin/chem3": return (this.breadCrumb('chem-3'))
      case "/admin/allDosages": return (this.breadCrumb('all-dosages'))
      default:
        break;
    }
  }
  bgColorAdmin = (page) => {
    if (page === "/admin/chem1" || page === "/admin/chem2" || page === "/admin/chem3" || page === "/admin/allDosages") {
      return "bg-green-500 relative md:pt-32 pb-128 pt-12"
    } else {
      return "bg-blue-500 relative md:pt-32 pb-128 pt-12"
    }
  }
  render() {
    const { page } = this.props;
    return (
      <>
        {/* Navbar */}
        <div className={this.bgColorAdmin(history.location.pathname)}>
          <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-no-wrap md:justify-start flex items-center p-4">
            <div className="w-full mx-autp items-center flex justify-between md:flex-no-wrap flex-wrap md:px-10 px-4">
              {/* Brand */}

              {
                this.pageLocation(page)
              }
              {/* div */}
              <div className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
                <div className="relative flex w-full flex-wrap items-stretch mr-3">
                  <button className="text-white background-transparent font-bold uppercase px-3 py-1 text-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                    <i className="fas fa-play-circle fa-2x"></i>
                  </button>
                  <IndexDropdown />
                </div>
              </div>
              {/* User */}
              <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
                <UserDropdown />
              </ul>
            </div>
          </nav>
        </div>
        {/* End Navbar */}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    page: history.location.pathname
  }
}
export default connect(mapStateToProps, { logout })(Navbar);